import { Breadcrumbs, ActionIcon } from "@mantine/core";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PAYER_TYPES } from "@turizi/shared";
import { BUSINESSES_PATH, navigate, PERSONS_PATH, SERVICES_PATH } from "@/lib/navigation";
import GlobalSearch from "./global-search";
import { IconMenu2 } from "@tabler/icons-react";
import { useMenuState } from "@/hooks/use-menu-state";
import NotificationsDropdown from "./notifications/notifications-dropdown";
import MyBusinessSelector from "./my-business-selector";
import CreateActionsMenu from "./create-actions-menu";


export default function TopNavbar(): JSX.Element {
    const { t } = useTranslation();
    const location = useLocation();
    const { toggleMenu, isMobile } = useMenuState();

    const generateBreadcrumbs = () => {
        const pathSegments = location.pathname.split('/').filter(Boolean);
        const breadcrumbItems = [];
        let currentPath = '';

        pathSegments.forEach((segment, index) => {
            if (segment === 'admin') {
                return;
            }
            currentPath += `/${segment}`;
            // Check if segment is numeric ID or regular path segment
            const label = /^\d+$/.test(segment)
                ? segment // Show numeric IDs as-is
                : t(segment.replace(/-/g, '_')) || segment.charAt(0).toUpperCase() + segment.slice(1);

            breadcrumbItems.push({
                title: label,
                href: currentPath
            });
        });

        return breadcrumbItems;
    };

    if (isMobile) {
        return (
            <div className='flex justify-between items-center h-full px-3 sm:px-4 bg-white print:hidden w-full gap-2'>
                <Link to="/" className="flex items-center shrink-0">
                    <img src="/images/favicon.svg" className="w-8 h-6" alt="Logo" />
                </Link>
                <div className="flex-1 min-w-0 max-w-[160px] xs:max-w-[220px]">
                    <GlobalSearch
                        isCollapsed={false}
                        onSelect={(item) => {
                            if (item.type === PAYER_TYPES.PERSON) {
                                navigate(`${PERSONS_PATH}/${item.id}`);
                            }
                            if (item.type === PAYER_TYPES.BUSINESS) {
                                navigate(`${BUSINESSES_PATH}/${item.id}`);
                            }
                            if (item.type === 'service') {
                                navigate(`${SERVICES_PATH}/${item.id}`);
                            }
                        }}
                    />
                </div>
                <div className="flex items-center gap-1 sm:gap-2 shrink-0">
                    <CreateActionsMenu isCollapsed={false} />
                    <NotificationsDropdown />
                    <ActionIcon onClick={toggleMenu} variant="subtle" size="md">
                        <IconMenu2 size={22} stroke={1.5} className="text-gray-700" />
                    </ActionIcon>
                </div>
            </div>
        )
    }

    return (
        <div className="flex items-center justify-between h-full w-full px-4 bg-white">
            <div className="flex items-center flex-1">
                <Link to="/" className="flex items-center justify-center flex-shrink-0 block mr-2">
                    <img src="/images/favicon.svg" className="h-8" alt="Logo" />
                </Link>
                <GlobalSearch
                    isCollapsed={false}
                    onSelect={(item) => {
                        if (item.type === PAYER_TYPES.PERSON) {
                            navigate(`${PERSONS_PATH}/${item.id}`);
                        }
                        if (item.type === PAYER_TYPES.BUSINESS) {
                            navigate(`${BUSINESSES_PATH}/${item.id}`);
                        }
                        if (item.type === 'service') {
                            navigate(`${SERVICES_PATH}/${item.id}`);
                        }
                    }}
                />
                <div className="ml-4">
                    <CreateActionsMenu isCollapsed={false} />
                </div>
            </div>

            <div>
                <Breadcrumbs separator="/" >
                    {generateBreadcrumbs().map((item, index) => (
                        <Link
                            key={index}
                            to={item.href}
                            style={{ color: 'inherit', textDecoration: 'none' }}
                        >
                            <div className="text-black text-md font-semibold p-1 hover:bg-green-100/80 rounded-md">
                                {item.title}
                            </div>
                        </Link>
                    ))}
                </Breadcrumbs>
            </div>

            <div className="flex-1 items-center justify-end flex">
                {/* <MyBusinessSelector
                    onSelect={(b) => {
                        navigate(`${BUSINESSES_PATH}/${b.id}`)
                    }}
                /> */}
                <NotificationsDropdown />
            </div>
        </div>
    );
}